const phone = (value: any) => {
  return value.length === 10;
};

const constMaskedPhone = (value: string) => {
  return /\(\d\d\d\) \d\d\d-\d\d-\d\d/.test(value);
};

export { phone, constMaskedPhone };



// WEBPACK FOOTER //
// ./src/tools/validators/phoneValidators.ts